
import { defineComponent } from 'vue';
import { SocialThreadType } from '@/models/Social/social-dialog';

export default defineComponent({
    props: {
        name:{
            type: String,
            default: ''
        },
        date:{
            type: String,
            default: undefined
        },
        type:{
            type: Number,
            default: () => SocialThreadType.Comment
        },
        typeText:{
            type: String,
            default: ''
        },
        verified:{
            type: Boolean,
            default: false
        },
    },
    computed: {
        isQuestion(){
            return this.type == SocialThreadType.Question;
        },
        isComment(){
            return this.type == SocialThreadType.Comment;
        },
        isPending(){
            return this.type == SocialThreadType.PendingComment;
        },
    }
});

